export default __webpack_public_path__ + "locales/hy-AM/PeopleTranslations.json?hash=1a9df78c24258ed1a2973bb4aa4c46a5";